import { render, staticRenderFns } from "./GridDePedidos.vue?vue&type=template&id=65dd075e&scoped=true&"
import script from "./GridDePedidos.vue?vue&type=script&lang=ts&"
export * from "./GridDePedidos.vue?vue&type=script&lang=ts&"
import style0 from "./GridDePedidos.vue?vue&type=style&index=0&id=65dd075e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dd075e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
